import { render, staticRenderFns } from "./VerifyBranchBusinessAddressPhoneStepper.vue?vue&type=template&id=7f959e7e&"
import script from "./VerifyBranchBusinessAddressPhoneStepper.vue?vue&type=script&lang=js&"
export * from "./VerifyBranchBusinessAddressPhoneStepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports